import { inject } from '@angular/core';
import { CanMatchFn, Route, Router } from '@angular/router';
import { AuthService } from '@core/authentication';
import { mergeMap, of } from 'rxjs';

export const RoleGuardFn: CanMatchFn = (route: Route) => {
  const router = inject(Router);
  const roles = route.data?.roles as string[];
  return inject(AuthService)
    .checkRoles(roles)
    .pipe(
      mergeMap(isAllowed => {
        if (!isAllowed) {
          return of(router.parseUrl('/sessions/403'));
        }

        return of(true);
      })
    );
};
